import { InjectionKey, reactive } from '@vue/composition-api'
import { FlagType } from '../ts/util/validate'

export type ValidatedType = {
    name: FlagType
    tel: FlagType
    email: FlagType
    zip: FlagType
    address: FlagType
    howto: FlagType
    ipad: FlagType
    shop: FlagType
    date: FlagType
    time: FlagType
    question: { [key: string]: FlagType }
    privacy: FlagType
    is_open_panel: boolean
    first_time: FlagType
}

export default function store() {
    const state = reactive<ValidatedType>({
        name: 0,
        tel: 0,
        email: 0,
        zip: 0,
        address: 0,
        howto: 0,
        ipad: 0,
        shop: 0,
        date: 0,
        time: 0,
        question: {},
        privacy: 0,
        is_open_panel: false,
        first_time: 0,
    })

    return {
        // name
        get name() {
            return state.name
        },
        set name(name) {
            state.name = name
        },

        // tel
        get tel() {
            return state.tel
        },
        set tel(tel) {
            state.tel = tel
        },

        // email
        get email() {
            return state.email
        },
        set email(email) {
            state.email = email
        },

        // zip
        get zip() {
            return state.zip
        },
        set zip(zip) {
            state.zip = zip
        },

        // address
        get address() {
            return state.address
        },
        set address(address) {
            state.address = address
        },

        // howto
        get howto() {
            return state.howto
        },
        set howto(howto) {
            state.howto = howto
        },

        // ipad
        get ipad() {
            return state.ipad
        },
        set ipad(ipad) {
            state.ipad = ipad
        },

        // shop
        get shop() {
            return state.shop
        },
        set shop(shop) {
            state.shop = shop
        },

        // date
        get date() {
            return state.date
        },
        set date(date) {
            state.date = date
        },

        // time
        get time() {
            return state.time
        },
        set time(time) {
            state.time = time
        },

        // question
        get question() {
            return state.question
        },
        set question(question) {
            state.question = { ...question }
        },

        // privacy
        get privacy() {
            return state.privacy
        },
        set privacy(privacy) {
            state.privacy = privacy
        },

        // is_open_panel
        get is_open_panel() {
            return state.is_open_panel
        },
        set is_open_panel(is_open_panel) {
            state.is_open_panel = is_open_panel
        },

        // first_time
        get first_time() {
            return state.first_time
        },
        set first_time(first_time) {
            state.first_time = first_time
        },
    }
}

export type StoreType = ReturnType<typeof store>
export const StoreKey: InjectionKey<StoreType> = Symbol('ValidatedType')
